export default __webpack_public_path__ + "static/learnotter-136ab550784b6efeb1ba4f60705d3fbf.png";